import React from 'react';
import { Navigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function ProtectedRoute({ children, permission, requireSiteAdmin }) {
  const { isAuthenticated, loading, hasPermission, isSiteAdmin, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-screen"><div className="spinner" />Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Email-verification gate: unverified users land on /signup/pending,
  // which doubles as the post-signup waiting screen (P1-A).
  // is_root/can_manage_admins keep their existing exemption.
  if (user && user.email_verified_at === null && !(user.is_root || user.can_manage_admins)) {
    return <Navigate to="/signup/pending" state={{ from: location, email: user.email }} replace />;
  }

  if (requireSiteAdmin && !isSiteAdmin) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>This page is restricted to site administrators.</p>
        <div className="access-denied-info">
          <p>If you believe this is an error, please contact:</p>
          <p className="access-denied-email"><a href="mailto:hello@whereat.kr">hello@whereat.kr</a></p>
        </div>
        <div className="access-denied-actions">
          <Link to="/profile" className="btn-sm">Go to Profile</Link>
        </div>
      </div>
    );
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p>You don't have permission to access this page.</p>
        <div className="access-denied-info">
          <p>If you believe this is an error, please contact your Org-Admin or reach out to us:</p>
          <p className="access-denied-email"><a href="mailto:hello@whereat.kr">hello@whereat.kr</a></p>
        </div>
        <div className="access-denied-actions">
          <Link to="/profile" className="btn-sm">Go to Profile</Link>
        </div>
      </div>
    );
  }

  return children;
}
